// extracted by mini-css-extract-plugin
export default {"snackBarWrapper":"snackbar_snackBarWrapper__xQOlt","relative":"snackbar_relative__QIIGS","absolute":"snackbar_absolute__RXorK"};